import { useState } from "react";
import { Link } from "react-router-dom";
import heroImage from '../assets/contacthero.webp';

const QuoteRequestForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
    });
    const [status, setStatus] = useState(null);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);

        const formDataToSend = new FormData();
        formDataToSend.append("type", "quote");
        formDataToSend.append("name", formData.name);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("phone", formData.phone);
        formDataToSend.append("service", formData.service);
        formDataToSend.append("message", formData.message);

        try {
            const response = await fetch("/send_mail.php", {
                method: "POST",
                body: formDataToSend,
            });

            const result = await response.json();

            if (result.ok) {
                setStatus({ type: "success", message: result.message });
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    service: "",
                    message: "",
                });
            } else {
                setStatus({ type: "error", message: result.message });
            }
        } catch (error) {
            setStatus({ type: "error", message: "Something went wrong. Please try again." });
        }
    };


    return (
        <section className="w-full items-center">
            <section
                className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center mb-10"
                style={{ backgroundImage: `url(${heroImage})` }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-75"></div>
                <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
                    <h1 className="text-4xl md:text-5xl  font-bold mb-4">
                        Request a Quote
                    </h1>
                    <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
                        <Link to="/" className="hover:text-white cursor-pointer">
                            Home
                        </Link>
                        <span>/</span>
                        <Link to="/about" className="text-gray-300 underline hover:text-white cursor-pointer">
                            Quote Request
                        </Link>
                    </div>
                </div>
            </section>
            <div className="max-w-4xl mx-auto px-6 mb-16">
                {/* <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-gray-800">
                        Request a Quote
                    </h2> */}
                <p className="text-center text-gray-600 mb-10">
                    Please fill out the form below to request a free quotation for our
                    services. We will get back to you as soon as possible.
                </p>

                <form
                    onSubmit={handleSubmit}
                    className="bg-white shadow-lg rounded-2xl p-8 space-y-6"
                >
                    {/* Name */}
                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Full Name
                        </label>
                        <input
                            type="text"
                            name="name"
                            placeholder="Your full name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                    </div>

                    {/* Email */}
                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Email Address
                        </label>
                        <input
                            type="email"
                            name="email"
                            placeholder="Your email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                    </div>

                    {/* Phone */}
                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Phone Number
                        </label>
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Your phone number"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                    </div>

                    {/* Service */}
                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Select Service
                        </label>
                        <select
                            name="service"
                            value={formData.service}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            <option value="">-- Choose a Service --</option>
                            <option value="Design & Building Construction">
                                Design & Building Construction
                            </option>
                            <option value="Building Materials Supply">
                                Building Materials Supply
                            </option>
                            <option value="Fire Equipment Installation & Maintenance">
                                Fire Equipment Installation & Maintenance
                            </option>
                            <option value="Construction Machinery & Equipment Rent">
                                Construction Machinery & Equipment Rent
                            </option>
                        </select>
                    </div>

                    {/* Message */}
                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Additional Details
                        </label>
                        <textarea
                            name="message"
                            placeholder="Write your project details here..."
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                        ></textarea>
                    </div>

                    {/* Submit */}
                    <div className="text-center">
                        <button
                            type="submit"
                            className="w-full md:w-auto px-6 py-3 bg-primary text-white font-semibold rounded-lg shadow-md hover:bg-primary/80 transition"
                        >
                            Submit Request
                        </button>
                    </div>
                    {status && (
                        <p
                            className={`mt-4 text-center ${status.type === "success" ? "text-green-600" : "text-red-600"
                                }`}
                        >
                            {status.message}
                        </p>
                    )}

                </form>
            </div>

        </section>
    );
};

export default QuoteRequestForm;
